export enum RouteNames {
  NOT_FOUND = "not-found",
}
